import { getMasterPhotoById, shouldGetOwnImage } from '@/helpers/images-helper';

const mapToPlayers = (players, selfImage, primary, number, goalkeeperPrimary, goalkeeperNumber) => {
    return players?.map((player) => {
        const base = {
            id: player?.i,
            name: player?.n,
            ...(player?.g !== null && player?.g !== undefined && { grid: player.g }),
            ...(player?.c != null && { chance: player.c }),
            ...(player?.s != null && { status: player.s }),
            ...(player?.l != null && { statusLevel: player.l }),
            ...(player?.a != null && { alternatives: player.a }),
            ...(player?.nb != null && { number: player.nb }),
            ...(player?.pid != null && { positionId: player.pid }),
            ...(selfImage && { image: getMasterPhotoById(player.i) }),
            ...(player?.fmv != null && { laLigaFantasyMarketValue: player.fmv }),
            ...(player?.fp != null && { laLigaFantasyPoints: player.fp }),
            ...(player?.fa != null && { laLigaFantasyAverage: player.fa }),
            ...(player?.fs != null && { laLigaFantasySubida: player.fs }),
            ...(player?.bmv != null && { biwengerMarketValue: player.bmv }),
            ...(player?.bs != null && { biwengerSubida: player.bs }),
            ...(player?.bsap != null && { biwengerAsPoints: player.bsap }),
            ...(player?.bsfp != null && { biwengerSofascorePoints: player.bsfp }),
            ...(player?.bstp != null && { biwengerStatsPoints: player.bstp }),
            ...(player?.bavp != null && { biwengerAveragePoints: player.bavp }),
            ...(player?.bsop != null && { biwengerSocialPoints: player.bsop }),
            ...(player?.isc != null && { isCapitan: player.isc }),
            ...(player?.isr != null && { isRevulsivo: player.isr }),
            ...(player?.isb != null && { isBufon: player.isb }),
            ...(player?.isa != null && { isAriete: player.isa }),
            ...(player?.isch != null && { isChollo: player.isch }),
            ...(player?.isn != null && { isNoInscrito: player.isn }),
            ...(player?.r != null && { report: player.r }),
            ...(player?.si != null && { statusInfo: player.si }),
            ...(player?.co != null && { comentario: player.co }),
            ...(player?.sl != null && { slug: player.sl }),
            ...(player?.fmmv != null && { fantasyMarcaMarketValue: player.fmmv }),
            ...(player?.fms != null && { fantasyMarcaSubida: player.fms }),
            ...(player?.mfmv != null && { misterFantasyMarketValue: player.mfmv }),
            ...(player?.mfs != null && { misterFantasySubida: player.mfs }),
            ...(player?.isco != null && { isConvocado: player.isco }),
            ...(player?.coco != null && { countryConvocado: player.coco }),
            ...(player?.yc != null && { cards: player.yc }),
        };

        const isGoalkeeper = player?.pid === 1;
        return {
            ...base,
            primary: isGoalkeeper ? goalkeeperPrimary : primary,
            colorNumber: isGoalkeeper ? goalkeeperNumber : number,
        };
    });
};

export const mapToFixtures = (fixtures) => {
    if (!fixtures || fixtures.length === 0 || !fixtures[0]?.id) return null;
    return fixtures?.map((fixture) => ({
        ...(fixture?.st != null && { status: fixture.st }),
        ...(fixture?.el != null && { elapsed: fixture.el }),
        ...(fixture?.r != null && { round: fixture.r }),
        ...(fixture?.l != null && { league: fixture.l }),
        home: {
            ...(fixture?.h?.i != null && { id: fixture.h.i }),
            ...(fixture?.h?.n != null && { name: fixture.h.n }),
            ...(fixture?.h?.g != null && { goals: fixture.h.g }),
        },
        away: {
            ...(fixture?.a?.i != null && { id: fixture.a.i }),
            ...(fixture?.a?.n != null && { name: fixture.a.n }),
            ...(fixture?.a?.g != null && { goals: fixture.a.g }),
        },
        ...(fixture?.d != null && { date: fixture.d }),
        ...(fixture?.id != null && { id: fixture.id }),
    }));
};

export const mapToTeam = (team) => {
    if (!team) return null;
    const selfImage = shouldGetOwnImage(team?.i);
    return {
        ...(team?.l != null && {
            lineup: mapToPlayers(team.l, selfImage, team?.p, team?.cn, team?.gp, team?.gn),
        }),
        ...(team?.i != null && { id: team.i }),
        ...(team?.n != null && { name: team.n }),
        ...(team?.d != null && {
            dificultad: {
                ...(team.d.po != null && { po: team.d.po }),
                ...(team.d.df != null && { df: team.d.df }),
                ...(team.d.mc != null && { mc: team.d.mc }),
                ...(team.d.dl != null && { dl: team.d.dl }),
                pr:
                    (Number(team?.d?.po ?? 0) +
                        Number(team?.d?.df ?? 0) +
                        Number(team?.d?.mc ?? 0) +
                        Number(team?.d?.dl ?? 0)) /
                    4,
            },
        }),
        ...(team?.nx != null && { next: mapToFixtures(team.nx) }),
        ...(team?.ls != null && { last: mapToFixtures(team.ls) }),
        ...(team?.lf != null && { lastFixture: mapToFixtures([team.lf])?.[0] }),
        ...(team?.y != null && { youtube: team.y }),
        ...(team?.f != null && { formation: team.f }),
        ...(team?.hpp != null && { hasPreviaPublica: team.hpp }),
    };
};

export const mapToEvents = (events) => {
    const resultEvents = events?.map((event) => ({
        ...(event?.a != null && {
            assist: {
                ...(event.a.i != null && { id: event.a.i }),
                ...(event.a.n != null && { name: event.a.n }),
            },
        }),
        ...(event?.c != null && { comments: event.c }),
        ...(event?.d != null && { detail: event.d }),
        ...(event?.ir != null && { isRemoved: event.ir }),
        ...(event?.p != null && {
            player: {
                ...(event.p.i != null && { id: event.p.i }),
                ...(event.p.n != null && { name: event.p.n }),
            },
        }),
        ...(event?.te != null && {
            team: {
                ...(event.te.i != null && { id: event.te.i }),
                ...(event.te.n != null && { name: event.te.n }),
            },
        }),
        ...(event?.ti != null && {
            time: {
                ...(event.ti.el != null && { elapsed: event.ti.el }),
                ...(event.ti.ex != null && { extra: event.ti.ex }),
            },
        }),
        ...(event?.ty != null && { type: event.ty }),
    }));

    return resultEvents;
};

export const mapToAlineacionesProbables = (data) => {
    const mapped = {
        ...(data?.f != null && {
            fixture: {
                ...(data.f.i != null && { id: data.f.i }),
                ...(data.f.st != null && { status: data.f.st }),
                ...(data.f.l != null && { league: data.f.l }),
                ...(data.f.r != null && { round: data.f.r }),
                ...(data.f.d != null && { date: data.f.d }),
                ...(data.f.rf != null && { referee: data.f.rf }),
                ...(data.f.s != null && { stadium: data.f.s }),
                ...(data.f.se != null && { season: data.f.se }),
                ...(data.f.h != null && {
                    home: {
                        ...(data.f.h.i != null && { id: data.f.h.i }),
                        ...(data.f.h.n != null && { name: data.f.h.n }),
                        ...(data.f.h.g != null && { goals: data.f.h.g }),
                    },
                }),
                ...(data.f.a != null && {
                    away: {
                        ...(data.f.a.i != null && { id: data.f.a.i }),
                        ...(data.f.a.n != null && { name: data.f.a.n }),
                        ...(data.f.a.g != null && { goals: data.f.a.g }),
                    },
                }),
            },
        }),
        ...(data?.h != null && { home: mapToTeam(data.h) }),
        ...(data?.a != null && { away: mapToTeam(data.a) }),
        ...(data?.l != null && { lastTimeUpdated: data.l }),
        ...(data?.m != null && { mode: data.m }),
        ...(data?.ep != null && { estadisticasPartido: data.ep }),
    };
    return mapped;
};

export const mapToH2hFixtures = (fixtures) => {
    return (
        fixtures
            ?.map((fixture) => ({
                ...(fixture?.t?.h != null && {
                    home: {
                        ...(fixture.t.h.i != null && { id: fixture.t.h.i }),
                        ...(fixture.t.h.n != null && { name: fixture.t.h.n }),
                        ...(fixture.g?.h != null && { goals: fixture.g.h }),
                    },
                }),
                ...(fixture?.t?.a != null && {
                    away: {
                        ...(fixture.t.a.i != null && { id: fixture.t.a.i }),
                        ...(fixture.t.a.n != null && { name: fixture.t.a.n }),
                        ...(fixture.g?.a != null && { goals: fixture.g.a }),
                    },
                }),
                ...(fixture?.f?.i != null && { id: fixture.f.i }),
                ...(fixture?.l?.i != null && { league: fixture.l.i }),
                ...(fixture?.l?.r != null && { round: fixture.l.r }),
                ...(fixture?.d != null && { date: fixture.d }),
            }))
            ?.sort((a, b) => new Date(b.date) - new Date(a.date)) ?? []
    );
};

export const mapToStatsEquipo = (team) => {
    const isHomeValid = team?.h != null && Object.keys(team?.h || {}).length > 0;
    const isAwayValid = team?.a != null && Object.keys(team?.a || {}).length > 0;
    const isAllValid = team?.all != null && Object.keys(team?.all || {}).length > 0;
    return {
        ...(team?.pos != null && { position: team.pos }),
        ...(team?.f != null && { form: team.f }),
        ...(isHomeValid && {
            home: {
                ...(team.h.v != null && { victorias: team.h.v }),
                ...(team.h.d != null && { derrotas: team.h.d }),
                ...(team.h.e != null && { empates: team.h.e }),
                ...(team.h.ga != null && { golesFavor: team.h.ga }),
                ...(team.h.ge != null && { golesContra: team.h.ge }),
                puntos: Number(team?.h?.v ?? 0) * 3 + Number(team?.h?.e ?? 0),
            },
        }),
        ...(isAwayValid && {
            away: {
                ...(team.a.v != null && { victorias: team.a.v }),
                ...(team.a.d != null && { derrotas: team.a.d }),
                ...(team.a.e != null && { empates: team.a.e }),
                ...(team.a.ga != null && { golesFavor: team.a.ga }),
                ...(team.a.ge != null && { golesContra: team.a.ge }),
                puntos: Number(team?.a?.v ?? 0) * 3 + Number(team?.a?.e ?? 0),
            },
        }),
        ...(isAllValid && {
            total: {
                ...(team.all.v != null && { victorias: team.all.v }),
                ...(team.all.d != null && { derrotas: team.all.d }),
                ...(team.all.e != null && { empates: team.all.e }),
                ...(team.all.ga != null && { golesFavor: team.all.ga }),
                ...(team.all.ge != null && { golesContra: team.all.ge }),
                puntos: Number(team?.all?.v ?? 0) * 3 + Number(team?.all?.e ?? 0),
            },
        }),
    };
};

export const mapToStats = (home, away) => {
    const response = {
        ...(home != null && { home: mapToStatsEquipo(home) }),
        ...(away != null && { away: mapToStatsEquipo(away) }),
    };

    return response;
};
